import React/*, { Component }*/ from "react";
import { compose } from 'redux';
import PropTypes from "prop-types";
import { GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-material/dist/all.css";
import { /*Input, */NumericTextBox } from '@progress/kendo-react-inputs';
import Header from "../components/Header";
import queryString from "query-string";
import Tabs from "../components/Tabs";
import Tab from "../components/Tab";
import ReportsDataFilters from "../components/ReportsDataFilters";
import config from '../config/config'
import isPage from "../hoc/isPage";
import { AppContext } from "../context/AppContext";
import { isEmpty, /*qremoveSpaces*/ queryStringBuilder, kebabCase, getExportFileName, } from "../helpers";
import {
    DateCell,
    //EditBookingButtonCell,
    BlankCell,
    CurrencyCell
} from "../components/utils/GridHelpers";
import GridContainer, { GridContainerToolbar, GridContainerToolbarOption } from '../components/GridContainer';
import moment from 'moment';
import localize from "../hoc/localize";
import { Button } from '@progress/kendo-react-buttons';
import { Redirect, Prompt } from "react-router-dom";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import DatePickerContainer from "../components/DatePickerContainer";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import CurrencyContainer from '../components/CurrencyContainer';

const NavigateAwayDialog = (props) => {

    //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
    let top = window.pageYOffset + (window.innerHeight - 200) / 2;
    return (
        <Dialog className="confirmation"
            width={400}
            style={{ height: 'auto', top: top, margin: '0 auto' }}
            onClose={props.handleCloseDialog}>

            {props.labels[0]}
            <DialogActionsBar>
                <Button className="cancel" onClick={props.handleCloseDialog}>{props.labels[1]}</Button>
                <Button style={{ background: "red" }} className="yes" primary={true} onClick={(e) => {
                    props.handleSaveChanges();
                    props.handleConfirmNavigate();
                    props.handleCloseDialog();
                }}>{props.labels[2]}</Button>
                <Button className="no" onClick={(e) => {
                    props.handleConfirmNavigate();
                    props.handleCloseDialog();
                }}>{props.labels[3]}</Button>
            </DialogActionsBar>
        </Dialog>
    )
}
NavigateAwayDialog.propTypes = {
    handleConfirmNavigate: PropTypes.func,
    handleCloseDialog: PropTypes.func,
    handleSaveChanges: PropTypes.func,
    labels: PropTypes.array
}

//hardcoded filter values to pass to reportDataFilters. since the filters normally take this.context.state values, we can't edit those every time someone wants to see an old report. 
//all filters and apply button are set to disabled, this component just enables formatting and look to be consistent 
class EditBookingFilters extends React.Component {

    handleClick = () => {
        return;
    }
    render() {
        let startDate = moment(this.props.startDate, 'YYYYMMDD').toDate();
        let endDate = moment(this.props.endDate, 'YYYYMMDD').toDate();
        return (
            <div>
                <div className="date-filter">
                    <span className="k-form-field">
                        <label htmlFor="startDate">{this.props.returnLocalizedString("m0479")}</label>{" "}
                        <DatePickerContainer
                            id="startDate"
                            value={startDate}
                            required={true}
                            label={this.props.returnLocalizedString("m0481")}
                            name="disabledFilterStartDate"
                            disabled={true}
                            handleClearDate={this.handleClick}

                        />
                    </span>
                    <span className="k-form-field">
                        <label htmlFor="endDate">{this.props.returnLocalizedString("m0480")}</label>{" "}
                        <DatePickerContainer
                            id="endDate"
                            value={endDate}
                            label={this.props.returnLocalizedString("m0482")}
                            name="disabledFilterEndDate"
                            disabled={true}
                            handleClearDate={this.handleClick}
                        />
                    </span>
                </div>

                <div className="k-form-field bottom-margin-10">
                    <label htmlFor="disabledFilterReportVendor">{this.props.returnLocalizedString("m0259")}</label>{" "}
                    <DropDownList
                        value={this.props.vendorName ? this.props.vendorName : this.props.returnLocalizedString("m0552")}
                        disabled={true}
                    />
                </div>
                <div className="k-form-field bottom-margin-10">
                    <label htmlFor="disabledFilterReportGroup">{this.props.returnLocalizedString("m0475")}</label>{" "}
                    <DropDownList
                        value={this.props.partGroup ? this.props.partGroup : this.props.returnLocalizedString("m0438")}
                        disabled={true}
                    />
                </div>
            </div>
        )
    }
}
const EditBookingFiltersLocalized = localize(EditBookingFilters)

class EditBookingButtonCell extends React.Component {
    //<Button look="default" title={this.props.title} onClick={this.props.handleClick}>{this.props.text}</Button>
    handleEditBooking = () => {
        this.props.handleEditBooking(this.props.dataItem.bookingID)
        //this.props.handleEditBooking(37)
    }
    render() {
        return (
            <td style={{ textAlign: "center" }}>
                <Button look="default" title={this.props.title} onClick={this.handleEditBooking}>{this.props.text}</Button>
            </td >
        )
    }
}
//}
//EditBookingButtonCell.defaultProps = {
//    disabled: false
//}

//used for Parts Booking report only
class DeleteRecordCell extends React.Component {

    handleClick = () => {
        this.props.showDeleteModal(this.props.dataItem.bookingID, this.props.dataItem);
    }

    render() {
        return (
            <td style={{ textAlign: "center" }}>
                <Button look="default" title={this.props.title} onClick={this.handleClick}>{this.props.text}</Button>
            </td>
        )
    }
}


class DescWithPackageInfoCell extends React.Component {
    render() {
        return (
            <td>
                {this.props.dataItem['partDescription']}
                {this.props.dataItem['package'] && (<div className="quantities"><span>{this.props.dataItem['packageUnit']}</span> {this.props.returnLocalizedString("m0254")}</div>)}
            </td>
        );
    }
}
const DescWithPackageInfoCellLocalized = localize(DescWithPackageInfoCell)

class SuggestedQtyWithPackageInfoCell extends React.Component {
    render() {

        let icon;
        switch (this.props.dataItem['suggestedQtyEnforcement']) {
            case 0:
                icon = <span className="k-icon" />
                break;
            case 1:
                icon = <span className="k-icon k-i-sort-asc-sm" />;
                break;
            case 2:
                icon = <span className="k-icon k-i-sort-desc-sm" />;
                break;
            default:
                break;
        }

        let className = 'numeric suggestedqty';
        if (this.props.dataItem['suggestedQuantity'] === 0)
            className += ' zerosuggested';
        //<img style={{ width: 5, height: 16, paddingLeft: 4 }} src={src} alt={alt} />
        return (
            <td className={className}>
                <div>
                    <span className="suggestedqty">{this.props.dataItem['suggestedQuantity'].toLocaleString()}</span>
                    {this.props.dataItem['package'] ? <span className="pkg">&nbsp;{this.props.returnLocalizedString("m0316")}</span> : <span className="pkg"></span>}
                    {icon}
                </div>
            </td>
        );
    }
}
const SuggestedQtyWithPackageInfoCellLocalized = localize(SuggestedQtyWithPackageInfoCell)


class OrderQuantityCell extends React.Component {

    element = null;

    handleOrderQuantityChange = (e) => {
        this.props.onChange({
            dataItem: this.props.dataItem,
            field: this.props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
            //value: e.target.value === null ? 0 : e.target.value
        });

        this.props.onChange({
            dataItem: this.props.dataItem,
            field: 'total',
            value: e.target.value * this.props.dataItem['cost']
        })
    }


    handleFocusOut = () => {
        if (isEmpty(this.element.value)) {
            //this.element.value = "0";
            this.props.onChange({
                dataItem: this.props.dataItem,
                field: this.props.field,
                value: 0
            });
        }
    }

    componentWillUnmount() {
        this.element.removeEventListener('focusout', this.handleFocusOut);
    }

    componentDidMount() {
        //console.log(this.props)
        this.element.addEventListener('focusout', this.handleFocusOut);
    }

    //zeroOutOrderQuantity = (e) => {
    //    this.props.onChange({
    //        dataItem: this.props.dataItem,
    //        field: 'orderQuantity',
    //        value: 0
    //    })
    //    this.props.onChange({
    //        dataItem: this.props.dataItem,
    //        field: 'total',
    //        value: 0
    //    })
    //}
    //<span onClick={this.zeroOutOrderQuantity} style={{'cursor': 'pointer'}}>X</span>

    //disabled={this.props.dataItem['neverOrder']}

    render() {
        let className = 'numeric orderqty';
        if (this.props.dataItem['updated'] > 0)
            className += ' updated';
        if (this.props.dataItem['orderQuantity'] > this.props.dataItem['suggestedQuantity'])
            className += ' greater';
        else if (this.props.dataItem['orderQuantity'] < this.props.dataItem['suggestedQuantity'])
            className += ' less';

        if (!this.props.dataItem.hasOwnProperty('suggestedQuantity')) {
            className = 'numeric returnqty'
        }
        return (
            <td className={className}>

                <MyNumericTextBox
                    width={"100%"}
                    min={0}
                    spinners={false}
                    name="orderQuantity"
                    onChange={this.handleOrderQuantityChange}
                    ref={(numericTextBox) => this.element = numericTextBox ? numericTextBox.element : null}
                    value={this.props.dataItem['orderQuantity']} />
            </td>
        )
    }
}

class MyNumericTextBox extends NumericTextBox {
    constructor(props) {
        super(props);

        this.wheel = null;
    }
}

function columnsPartsBooking(props) {
    return [
        { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0257"), minWidnt: 20, editable: false },
        { field: "vendorCode", key: "vendorCode", title: props.returnLocalizedString("m0259"), minWidnt: 20, editable: false },
        { field: "partDescription", key: "partDescription", title: props.returnLocalizedString("m0258"), minWidnt: 20, editable: false, cell: DescWithPackageInfoCellLocalized },
        { field: "totalSales", key: "totalSales", title: props.returnLocalizedString("m0373"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "totalSalesHit", key: "totalSalesHit", title: props.returnLocalizedString("m0374"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "totalQtySold", key: "totalQtySold", title: props.returnLocalizedString("m0345"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "qtySpecialOrdered", key: "qtySpecialOrdered", title: props.returnLocalizedString("m0347"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "maxSoldDate", key: "maxSoldDate", title: props.returnLocalizedString("m0324"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "currentQtyAvailable", key: "currentQtyAvailable", title: props.returnLocalizedString("m0348"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "currentQtyOnOrder", key: "currentQtyOnOrder", title: props.returnLocalizedString("m0349"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "currentQtySalesInProgress", key: "currentQtySalesInProgress", title: props.returnLocalizedString("m0350"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "productGroup", key: "productGroup", title: props.returnLocalizedString("m0351"), minWidnt: 20, editable: false },
        { field: "suggestedQuantity", key: "suggestedQuantity", title: props.returnLocalizedString("m0442"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: SuggestedQtyWithPackageInfoCellLocalized },
        { field: "orderQuantity", key: "orderQuantity", title: props.returnLocalizedString("m0315"), minWidnt: 20, editable: true, headerClassName: "numeric", className: "numeric", cell: OrderQuantityCell },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsPartsBookingHistory(props) {
    return [
        { field: "vendorName", key: "vendorName", title: props.returnLocalizedString("m0259"), minWidnt: 20, editable: false },
        { field: "startDate", key: "startDate", title: props.returnLocalizedString("m0481"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "endDate", key: "endDate", title: props.returnLocalizedString("m0482"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "partGroup", key: "partGroup", title: props.returnLocalizedString("m0600"), minWidnt: 20, editable: false },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsPartsReturn(props) {
    return [
        { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0257"), minWidnt: 20, editable: false },
        { field: "vendorCode", key: "vendorCode", title: props.returnLocalizedString("m0259"), minWidnt: 20, editable: false },
        { field: "partDescription", key: "partDescription", title: props.returnLocalizedString("m0258"), minWidnt: 20, editable: false, cell: DescWithPackageInfoCellLocalized },
        { field: "maxSoldDate", key: "maxSoldDate", title: props.returnLocalizedString("m0324"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "currentQtyAvailable", key: "currentQtyAvailable", title: props.returnLocalizedString("m0348"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "age", key: "age", title: props.returnLocalizedString("m0617"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "cost", key: "agedValue", title: props.returnLocalizedString("m0318"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "total", key: "total", title: props.returnLocalizedString("m0322"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "orderQuantity", key: "orderQuantity", title: props.returnLocalizedString("m0618"), minWidnt: 20, editable: true, headerClassName: "numeric", className: "numeric", cell: OrderQuantityCell },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};



const ADJUST_PADDING = 0;
const COLUMN_MIN = 4;

class BookingsPage extends React.Component {
    static propTypes = {

        role: PropTypes.shape({
            roleID: PropTypes.string,
            role: PropTypes.string  // name of role
        }),

        mode: PropTypes.oneOf([
            "booking",
            "editBooking",
            "return"
        ])
    }

    reportTitle = ""; // e.g. "Top Seller Items"
    reportType = ""; // e.g. top-seller-items
    values = null; // orderType - 0: all; 1: GM; 2: P&A

    // the "autoFilter" variables below are parameters passed when drilling down from other parts of the app
    autoFilterType = "";
    autoFilterStartDate; // start and end date to use for the drilldown run of this report
    autoFilterEndDate;
    previousPageUrl = "";
    previousPageTitle = "";

    minGridWidth = 0;

    constructor(props) {
        super(props);

        // url will always be formatted like this:
        // /reports/top-performers&reportTitle=Top Performers

        // we want to get:
        // the reportType - this will be the slug ("top-performers")
        // the reportTitle - this will be the querystring parameter value

        let vals = queryString.parse(window.location.search);

        // actual name of the report, e.g. "Top Seller Items"
        this.reportTitle = vals.reportTitle;
        //console.log('this.reportTitle', this.reportTitle)

        // 0: all; 1: GM; 2: P&A
        this.values = { orderType: "0", monthYear: "" };

        // if we're drilling down to this report from somewhere else (like the dashboard), then this will be populated.
        // it also means we're going to run the report automatically and that we won't show the report filters.
        this.autoFilterType = vals.autoFilterType;

        // if drilling down to this report, then you can also define a start and end date to the report.
        this.autoFilterStartDate = vals.autoFilterStartDate;
        this.autoFilterEndDate = vals.autoFilterEndDate;

        // create a link to the previous page (whatever that happens to be), so the user has an easy way to navigate back there.
        this.previousPageUrl = vals.previousPageUrl;
        this.previousPageTitle = vals.previousPageTitle;

        // get the URL minus the querystring.
        // we want to get the type of the report from the URL.
        // e.g. if the URL is /reports/top-seller-items, then this.reportType = "top-seller-items"
        const urlPath = window.location.href.replace(window.location.search, '');
        const urlPathFragments = urlPath.split('/');
        this.reportType = urlPathFragments[urlPathFragments.length - 1]


        this.state = {
            suggestedOrders: [],
            //columns: [],
            setMinWidth: false,
            gridCurrent: 0,
            currentResultSettings: [],
            unsaved: false, // indicates that changes have been made to the suggested order that haven't been saved yet
            nextLocation: '', // URL that the user attempted to navigate to before saving his changes
            performRedirect: false, // when set to true, indicates that user wants to navigate away without saving changes
            goToEditBooking: false,
            bookingID: null, //used to pass settings to edit booking page or delete booking records
            dataItem: null,
            showDeleteModal: false,
            settings: { startDate: 0o0, endDate: 0o0, bookingID: null, orgID: null, partGroup: null, vendorID: null, vendorName: null },
        };
    }

    state = {
        reportData: null,
        filterControls: null,
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleItemChange = (e) => {
        console.log('handleItemChange')
        e.dataItem[e.field] = e.value;
        e.dataItem['updated'] = e.dataItem['updated'] === 0 ? 1 : e.dataItem['updated'];

        const index = e.dataItem['index'];

        this.setState({
            reportData: Object.assign([], this.state.reportData, { [index]: e.dataItem }),
            unsaved: true
        });
    }

    componentDidMount() {
        // if we are drilling down to reports (which is the case if this.autoFilterType is nonempty),
        // then just run the report right away. don't show the report filters to the user. 
        // otherwise we'll expose the report filters to the user.
        if (this.reportType === "edit-parts-booking") {
            let bookingID = this.props.location.state ? this.props.location.state.bookingID : this.context.state.currentBookingID;
            //console.log(this.props.location.state)
            if (bookingID) {
                this.props
                    .getData(`/api/portal/report/partsbookinghistory?bookingID=${bookingID}`)
                    .then(response => {
                        this.setState({ settings: response.data[0] })
                    })
                let apiUrl = `/api/portal/booking/get?bookingID=${bookingID}`
                this.callApi(apiUrl)
            }
            else {
                this.setState({ reportData: [] })
            }
        }
        else {
            if (!isEmpty(this.autoFilterType)) {
                const params = {}
                params.autoFilterType = this.autoFilterType;

                //let builder = new queryStringBuilder();

                if (!isEmpty(this.autoFilterType)) {
                    params.autoFilterType = this.autoFilterType;
                }
                if (!isEmpty(this.autoFilterStartDate)) {
                    params.startDate = this.autoFilterStartDate;
                }
                if (!isEmpty(this.autoFilterEndDate)) {
                    params.endDate = this.autoFilterEndDate;
                }

                // 
                const qs = queryString.parse(window.location.search);
                if (qs.orgID) {
                    params.orgID = qs.orgID;
                }
                if (qs.reportGroupID) {
                    params.reportGroupID = qs.reportGroupID;
                }
                if (qs.vendorID) {
                    params.vendorID = qs.vendorID;
                }

                // grab the orgID, reportGroupID and vendorID

                const endpointSlug = this.reportType.replace(/-/g, '');
                //const apiUrl = `/api/portal/report/${endpointSlug}?${queryString.stringify(params)}`;
                let apiUrl;
                apiUrl = `${apiUrl}${endpointSlug}?`;
                apiUrl = `${apiUrl}${queryString.stringify(params)}`;
                this.callApi(apiUrl);
            }
        }
        //set default start date to one year ago (currently only booking and return reports have this as a feature)
        //console.log(this.context.state.selectedReportStartDate);
        if (!this.context.state.selectedReportStartDate) {
            //console.log(moment().add(-12, 'month').format("YYYYMMDD"))
            this.context.setState({ selectedReportStartDate: moment().add(-12, 'months').toDate() });
        }
        if (!this.context.state.selectedReportAge) {
            this.context.setState({ selectedReportAge: 12 });
        }
    }

    expandChange = e => {

        e.dataItem.expanded = !e.dataItem.expanded;
        this.forceUpdate();
    };


    getFilterValues = (values) => {
        this.values = values;
    }

    parseTitle(reportType) {
        //parse reportType slug into localisation code for rendering, adjust this when adding new reports
        switch (reportType) {
            case "parts-booking-tool":
                return "m0594";
            case "parts-booking-history":
                return "m0597";
            case "edit-parts-booking":
                return "m0601";
            case "parts-return":
                return "m0605";
            default:
                return ""
        }

    }

    initValue = () => {
        //console.log(this.reportType)
        //console.log(this.state.reportData)
        //if data needs process after api call
        if (this.reportType === "parts-booking-tool" || this.reportType === "edit-parts-booking") {
            for (let i = 0; i < this.state.reportData.length; i++) {
                let dataItem = this.state.reportData[i];
                const index = dataItem['index']
                dataItem["updated"] = 0;

                this.setState({
                    reportData: Object.assign([], this.state.reportData, { [index]: dataItem })
                });
            }
        }
        else if (this.reportType === "parts-return") {
            const maxVal = this.context.state.selectedReportMaxValue;
            var totalValue = 0
            for (let i = 0; i < this.state.reportData.length; i++) {
                let dataItem = this.state.reportData[i];
                let qty = dataItem["cost"] === 0 ? 0 : Math.min(Math.floor(dataItem["currentQtyAvailable"] / (dataItem["package"] ? dataItem["packageUnit"] : 1.0)), (Math.floor((maxVal - totalValue) / dataItem["cost"])));
                //console.log(dataItem);
                let addValue = dataItem["cost"] * qty;
                const index = dataItem['index']
                dataItem["total"] = addValue;
                dataItem["orderQuantity"] = qty;
                dataItem["updated"] = 0;
                totalValue = totalValue + addValue

                this.setState({
                    reportData: Object.assign([], this.state.reportData, { [index]: dataItem })
                });
            }
        }
        else {
            return
        }
    }


    // handles the submission of the search criteria, and RUN THE REPORT
    callApi = (apiUrl) => {
        //console.log(apiUrl);
        //https://dv0som000devweb01.azurewebsites.net/api/portal/report/TopSellerItems?startDate=2018-12-02T08:00:00.000Z&orgID=38
        this.props
            .getData(apiUrl)
            .then(response => {
                // grid may not exist yet, but it has the same width as the search-controls, so use it to calculate column widths
                //this.grid = document.querySelector('.k-grid');
                this.grid = document.querySelector('.report-search-panel');
                window.addEventListener('resize', this.handleResize);
                let columns;

                if (this.reportType === "parts-booking-tool" || this.reportType === "edit-parts-booking") {
                    columns = columnsPartsBooking(this.props);
                    this.minGridWidth = 1170;
                }
                else if (this.reportType === "parts-booking-history") {
                    columns = columnsPartsBookingHistory(this.props);
                    this.minGridWidth = 620;
                }
                else if (this.reportType === "parts-return") {
                    columns = columnsPartsReturn(this.props);
                    this.minGridWidth = 810;
                }
                columns.map(item => this.minGridWidth += item.minWidnt);

                this.setState({
                    reportData: response.data,

                    //columns: columns,
                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: this.grid.offsetWidth < this.minGridWidth
                }, function () {
                    this.initValue();
                });

            })
            .catch(error => {
                //console.log(error);
                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0371")
                );
            });
    };


    handleResize = () => {
        //console.log("grid.offsetWidth: ", this.grid.offsetWidth);

        if (this.grid) {
            if (this.grid.offsetWidth < this.minGridWidth && !this.state.setMinWidth) {
                this.setState({
                    setMinWidth: true
                });
            } else if (this.grid.offsetWidth > this.minGridWidth) {
                this.setState({
                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: false
                });
            }
        }
    }

    setWidth = (minWidth, percentage) => {
        //console.log("state.gridCurrent: ", this.state.gridCurrent);
        //if (this.grid)
        //    console.log("grid.offsetWidth: ", this.grid.offsetWidth);
        //let columnsLength;
        //if (this.context.state.allowEditSuggestedOrders)
        //    columnsLength = columnsAllowEdit.length;
        //else
        //    columnsLength = columnsNotAllowEdit.length;
        //let width = this.state.setMinWidth ? minWidth :
        //    minWidth + (this.state.gridCurrent - this.minGridWidth) / columnsLength;
        let width = this.state.setMinWidth ? minWidth :
            Math.round(this.state.gridCurrent / 100 * percentage);
        width = width < COLUMN_MIN ? width : width - ADJUST_PADDING;
        //console.log("width: ", width);
        return width;
    }

    getCsvData = () => {
        let csvData = [];

        const { allowEditSuggestedOrders } = this.context.state;

        this.state.reportData.forEach(order => {
            // if allowing user to edit suggested orders, then ....
            //      export order quantity (if defined, otherwise export suggested quantity)
            // else
            //      export suggested quantity only
            let quantity = (allowEditSuggestedOrders ? (isEmpty(order.orderQuantity) ? 0 : order.orderQuantity) : order.suggestedQuantity);
            if (quantity > 0) {
                csvData.push([
                    order.partNumber,
                    quantity
                ]);
            }

        });
        //console.log(csvData)
        return csvData;
    }

    getPartBookingFilename = (fileExtension) => {
        // vendor name (all spaces replaced by dashes, only if user is dealergroup) + "-" + dealer name (all spaces replaced by dashes) + "-Parts-Booking-" + report start date + report end date + ".csv"   
        const orgType = this.context.state.orgType;
        const orgName = isEmpty(this.context.state.selectedReportOrg) ? this.context.state.orgName : this.context.state.selectedReportOrg.orgName;
        let fileName = "";
        switch (orgType) {
            case 'dealergroup':
                fileName = this.context.state.orgName.replace(/\s/g, "-") + "-";
                fileName = `${fileName}` + orgName.replace(/\s/g, "-") + "-Parts-Booking-";
                break;
            default:
                fileName = `${fileName}` + orgName.replace(/\s/g, "-") + "-Parts-Booking-";
                break;
        }
        if (this.reportType === "edit-parts-booking") {
            if (!isEmpty(this.state.settings.startDate)) {
                fileName = `${fileName}` + moment(this.state.settings.startDate, "YYYYMMDD").format("YYYY-MM-DD")
            }
            else {
                fileName = `${fileName}` + moment(this.state.settings.startDate, "YYYYMMDD").subtract(31, "days").format("YYYY-MM-DD")
            }

            fileName = fileName + "-";

            if (!isEmpty(this.state.settings.endDate)) {
                fileName = `${fileName}` + moment(this.state.settings.endDate, "YYYYMMDD").format("YYYY-MM-DD")
            }
            else {
                fileName = `${fileName}` + moment().format("YYYY-MM-DD")
            }
        }
        else {
            if (!isEmpty(this.context.state.selectedReportStartDate)) {
                fileName = `${fileName}` + moment(this.context.state.selectedReportStartDate, "YYYYMMDD").format("YYYY-MM-DD");
            }
            else {
                fileName = `${fileName}` + moment(this.context.state.selectedReportStartDate, "YYYYMMDD").subtract(31, "days").format("YYYY-MM-DD");
            }

            fileName = fileName + "-";

            if (!isEmpty(this.context.state.selectedReportEndDate)) {
                fileName = `${fileName}` + moment(this.context.state.selectedReportEndDate, "YYYYMMDD").format("YYYY-MM-DD");
            }
            else {
                fileName = `${fileName}` + moment().format("YYYY-MM-DD");
            }
        }
        fileName = fileName + '.' + fileExtension;

        return fileName;
    }

    getTabs = () => {
        //const tabLabel = (isEmpty(this.previousPageTitle)) ? 'Go back to reports listing' : `Go back to ${this.previousPageTitle}`;
        //const tabLink = (isEmpty(this.previousPageUrl)) ? '/reports' : this.previousPageUrl;

        //<Tabs activeTab="0">
        //    <Tab label={tabLabel} link={tabLink} />
        //</Tabs>
        let label;
        let link;
        let linkParams;
        label = this.props.returnLocalizedString("m0596");
        link = '/booking-returns';
        linkParams = "";
        return (
            <Tabs>
                <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
                <Tab label={label} link={link} linkParams={linkParams} ></Tab>
                <Tab label={this.props.returnLocalizedString(this.parseTitle(this.reportType))} ></Tab>
            </Tabs>
        );
    }

    rowRender = (row, props) => {
        let newRow = row;
        return newRow;
    }

    // show dialog to confirm whether user wants to navigate away despite having unsaved changes
    showNavigateAwayDialog = (location) => {
        //debugger;
        this.setState({
            showNavigateAwayDialog: true,
            nextLocation: location
        })
    }

    showDeleteModal = (bookingID, dataItem) => {
        this.setState({
            showDeleteModal: true,
            bookingID: bookingID,
            dataItem: dataItem
        });
    };
    handleCloseModal = () => {
        this.setState({
            showDeleteModal: false,
        });
    };

    // navigate away
    handleConfirmNavigate = () => {
        this.setState({
            performRedirect: true
        })
    }

    // close the "are you sure you want to leave without saving changes" dialog
    handleCloseDialog = () => {
        this.setState({
            showNavigateAwayDialog: false
        })
    }

    handleDeleteRecord = (bookingID, dataItem) => {
        //console.log(dataItem);

        for (let i = 0; i < this.state.reportData.length; i++) {
            if (this.state.reportData[i] === this.state.dataItem) {
                this.setState({ reportData: this.state.reportData.slice(0, i).concat(this.state.reportData.slice(i + 1)) })
            }
        }

        let apiUrl = "/api/portal/booking/delete"
        let builder = new queryStringBuilder();
        builder.append("bookingID", this.state.bookingID)
        apiUrl = `${apiUrl}${builder.queryString}`
        this.props
            .deleteData(apiUrl)
            .then(response => {
                //console.log(response)
            })
            .catch(error => {
                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0602")
                );
            });
        this.handleCloseModal();
    }

    handleEditBooking = (bookingID) => {
        this.setState({ goToEditBooking: true, bookingID: bookingID })
        this.context.setState({ currentBookingID: bookingID })
    }

    handleSaveChanges = () => {
        let saveApiUrl = "/api/portal/booking/save"
        let builder = new queryStringBuilder();

        if (this.reportType === "edit-parts-booking") {
            let orgID = this.state.settings.orgID;
            let vendorID = this.state.settings.vendorID;
            let partGroup = this.state.settings.partGroup;
            let startDate = this.state.settings.startDate;
            let endDate = this.state.settings.endDate;
            if (orgID) {
                builder.append("orgID", orgID)
            }
            if (partGroup) {
                builder.append("partGroup", partGroup)
            }
            if (startDate) {
                builder.append("startDate", startDate)
            }
            if (endDate) {
                builder.append("endDate", endDate)
            }
            builder.append("active", true)
            builder.append("vendorID", vendorID)

            saveApiUrl = `${saveApiUrl}${builder.queryString}`
            this.props
                .postData(saveApiUrl, this.state.reportData)
                .then(response => {
                    //console.log(response)
                })
                .catch(error => {
                    this.props.alert(
                        "error",
                        this.props.returnLocalizedString("m0023"),
                        this.props.returnLocalizedString("m0599")
                    );
                });
            this.setState({ unsaved: false })
        }
        else {
            const orgID = this.context.state.selectedReportOrg
                ? this.context.state.selectedReportOrg.orgID
                : null;

            const partGroupID = this.context.state.selectedReportPartGroup
                ? this.context.state.selectedReportPartGroup.partGroupID
                : null;

            const selectedReportVendor = this.context.state.selectedReportVendor;
            //let orgVendorID;
            let vendorID;
            if (selectedReportVendor) {
                if (selectedReportVendor.hasOwnProperty("vendorID")) {
                    // from DropDownContainer with dataType majorVendors or adminVendors
                    vendorID = selectedReportVendor.vendorID;
                }
                if (selectedReportVendor.hasOwnProperty("orgVendorID")) {
                    // from DropDownContainer with dataType vendors
                    if (orgID === 0) {
                        // the logged on user is a dealer group user, the orgVendorID is actually vendorID
                        vendorID = selectedReportVendor.orgVendorID;
                    }
                    //else {
                    //    orgVendorID = selectedReportVendor.orgVendorID;
                    //}
                }
            }

            const startDate = this.context.state.selectedReportStartDate
                ? moment(this.context.state.selectedReportStartDate).format(
                    "YYYYMMDD"
                )
                : null;

            const endDate = this.context.state.selectedReportEndDate
                ? moment(this.context.state.selectedReportEndDate).format(
                    "YYYYMMDD"
                )
                : null;
            if (orgID) {
                builder.append("orgID", orgID)
            }
            if (vendorID) {
                builder.append("vendorID", vendorID)
            }
            if (partGroupID) {
                builder.append("partGroup", partGroupID)
            }
            if (true) {
                builder.append("active", true)
            }
            if (startDate) {
                builder.append("startDate", startDate)
            }
            if (endDate) {
                builder.append("endDate", endDate)
            }
            saveApiUrl = `${saveApiUrl}${builder.queryString}`
            this.props
                .postData(saveApiUrl, this.state.reportData)
                .then(response => {
                    //console.log(response)
                })
                .catch(error => {
                    this.props.alert(
                        "error",
                        this.props.returnLocalizedString("m0023"),
                        this.props.returnLocalizedString("m0599")
                    );
                });
            this.setState({ unsaved: false })
        }
    }

    render() {
        if (this.state.goToEditBooking) {
            return <Redirect to={{
                pathname: `/booking-returns/parts-booking-history/edit-parts-booking`,
                state: { bookingID: this.state.bookingID }
            }} />
        }
        // get the breadcrumbs
        const tabs = this.getTabs();

        // get the description for this particular report
        const reportTitle = kebabCase(this.reportTitle)
        const reportDescription = config.reportDescriptions[reportTitle]

        // create the mxxx code for label that goes into the header section of the page
        let headerLabel = '';
        //if (isEmpty(this.autoFilterType)) {
        //    headerLabel = 'Reports > ';
        //}
        headerLabel += this.parseTitle(this.reportType);
        //create file export name
        const exportFileName = kebabCase(this.props.returnLocalizedString(headerLabel))
        //const previousPageTitle = (isEmpty(this.previousPageTitle)) ? "Reports" : this.previousPageTitle;
        //const previousPageUrl = (isEmpty(this.previousPageUrl)) ? '/reports' : this.previousPageUrl;
        const previousPageTitle = '';
        const previousPageUrl = '';

        let saveButton = <React.Fragment />;
        if (this.context.state.allowEditSuggestedOrders) {
            saveButton = (
                <GridContainerToolbar>
                    <GridContainerToolbarOption type="save" tooltip="m0252" primary={true} handleClick={this.handleSaveChanges} />
                </GridContainerToolbar>
            )
        }

        if (this.state.performRedirect && (!isEmpty(this.state.nextLocation))) {

            return <Redirect to={this.state.nextLocation} />
        }
        let toolBarContent = "";
        if (this.reportType === "parts-return") {
            toolBarContent = (
                <span className="grid-totals">
                    <span className="info" style={{ fontSize: "16px" }}>
                        {this.props.returnLocalizedString("m0450")}&nbsp;<span><CurrencyContainer quantity={this.state.reportData ? this.state.reportData.reduce((a, b) => (
                            //console.log(a),
                            //console.log(b),
                            {
                                total: (a.total ? a.total : 0) + b['total']
                            }), 0).total : 0} /></span>
                    </span>
                </span>
            );
        }

        //!DBTRANS! @m0597@ Parts Booking History !DEVNOTE! Report Title
        //!DBTRANS! @m0599@ Unable to save Parts Booking !DEVNOTE! Error Message
        //!DBTRANS! @m0600@ Part Group !DEVNOTE! Column Title
        //!DBTRANS! @m0602@ Unable to delete Parts Booking !DEVNOTE! Error message
        //!DBTRANS! @m0603@ Delete !DEVNOTE! Button label
        //!DBTRANS! @m0604@ Do you want to delete this Parts Booking? !DEVNOTE! Dialog text
        //!DBTRANS! @m0605@ Parts Return !DEVNOTE! Report Title
        //!DBTRANS! @m0617@ Age (months) !DEVNOTE! Column Title
        //!DBTRANS! @m0618@ Suggested Return Qty !DEVNOTE! Column Title

        return (
            <AppContext.Consumer>
                {context => (
                    <div className="reports">
                        <Header title={this.props.returnLocalizedString(headerLabel)} tabs={tabs} toolTipText={this.props.returnLocalizedString(reportDescription)} previousPageTitle={previousPageTitle} previousPageUrl={previousPageUrl} />

                        {this.state.showNavigateAwayDialog && this.reportType === "parts-booking-tool" && (
                            <NavigateAwayDialog
                                handleConfirmNavigate={this.handleConfirmNavigate}
                                handleCloseDialog={this.handleCloseDialog}
                                handleSaveChanges={this.handleSaveChanges}
                                labels={[this.props.returnLocalizedString('m0251'), this.props.returnLocalizedString('m0101'), this.props.returnLocalizedString('m0252'), this.props.returnLocalizedString('m0253')]}
                            />
                        )}

                        {this.reportType === "parts-booking-tool" && <Prompt
                            when={this.state.unsaved}
                            message={location => {
                                this.showNavigateAwayDialog(`${location.pathname}${location.search}`);
                                return false
                            }}
                        />}

                        {this.state.showDeleteModal && this.reportType === "parts-booking-history" && (
                            <Dialog
                                title={this.props.returnLocalizedString("m0239")}
                                onClose={this.handleCloseModal}
                            >
                                <div>
                                    <span>
                                        {this.props.returnLocalizedString("m0604")}
                                    </span>

                                    <DialogActionsBar>
                                        <Button className="k-button" onClick={this.handleCloseModal}>{this.props.returnLocalizedString("m0175")}</Button>
                                        <Button className="k-button k-primary yes" onClick={this.handleDeleteRecord}>{this.props.returnLocalizedString("m0176")}</Button>
                                    </DialogActionsBar>
                                </div>
                            </Dialog>
                        )}

                        <section className="page-content grid-row pad-it">
                            {isEmpty(this.autoFilterType) && this.reportType !== "edit-parts-booking" && (
                                <ReportsDataFilters
                                    reportType={this.reportType}
                                    reportTitle={this.reportTitle}
                                    callApi={this.callApi}
                                    getFilterValues={this.getFilterValues}
                                    mode={"bookingReports"}
                                >
                                    {this.state.filterControls}

                                </ReportsDataFilters>
                            )}
                            {isEmpty(this.autoFilterType) && this.reportType === "edit-parts-booking" && (
                                <ReportsDataFilters
                                    reportType={"parts-booking-history"}
                                    disabled={true}
                                    disabledSettings={<EditBookingFiltersLocalized
                                        partGroup={this.state.settings.partGroup}
                                        vendorName={this.state.settings.vendorName}
                                        startDate={this.state.settings.startDate}
                                        endDate={this.state.settings.endDate}
                                    />}
                                    getFilterValues={this.getFilterValues}
                                    mode={"bookingReports"}
                                ></ReportsDataFilters>
                            )}

                            {this.reportType === "parts-return" && this.state.reportData && <GridToolbar>{toolBarContent}</GridToolbar>}

                            {(this.reportType === "parts-booking-tool" || this.reportType === "edit-parts-booking") && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={this.getPartBookingFilename("xlsx")}
                                    csvFilename={this.getPartBookingFilename("csv")}
                                    editField="inEdit"
                                    onItemChange={this.handleItemChange}
                                    csvData={this.getCsvData()}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    {saveButton}
                                    <Column
                                        field="partNumber"
                                        title={this.props.returnLocalizedString("m0257")}
                                        width={this.setWidth(85, 7)}
                                    />
                                    <Column
                                        field="vendorCode"
                                        title={this.props.returnLocalizedString("m0259")}
                                        width={this.setWidth(70, 6)}
                                    />
                                    <Column
                                        field="partDescription"
                                        title={this.props.returnLocalizedString("m0258")}
                                        width={this.setWidth(155, 13)}
                                        cell={DescWithPackageInfoCellLocalized}
                                    />
                                    <Column
                                        field="totalSales"
                                        title={this.props.returnLocalizedString("m0373")}
                                        width={this.setWidth(90, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="totalSalesHit"
                                        title={this.props.returnLocalizedString("m0374")}
                                        width={this.setWidth(55, 5)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="totalQtySold"
                                        title={this.props.returnLocalizedString("m0345")}
                                        width={this.setWidth(55, 5)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="qtySpecialOrdered"
                                        title={this.props.returnLocalizedString("m0347")}
                                        width={this.setWidth(65, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="maxSoldDate"
                                        title={this.props.returnLocalizedString("m0324")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(85, 7)}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="currentQtyAvailable"
                                        title={this.props.returnLocalizedString("m0348")}
                                        width={this.setWidth(85, 7)}
                                        className='numeric current'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="currentQtyOnOrder"
                                        title={this.props.returnLocalizedString("m0349")}
                                        width={this.setWidth(85, 7)}
                                        className='numeric current'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="currentQtySalesInProgress"
                                        title={this.props.returnLocalizedString("m0350")}
                                        width={this.setWidth(85, 7)}
                                        className='numeric current'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="productGroup"
                                        title={this.props.returnLocalizedString("m0351")}
                                        width={this.setWidth(75, 6)}
                                    />
                                    <Column
                                        field="suggestedQuantity"
                                        headerClassName="numeric suggestedqtynopkg"
                                        className="numeric"
                                        title={this.props.returnLocalizedString("m0442")}
                                        width={this.setWidth(95, 8)}
                                        editable={false}
                                        cell={SuggestedQtyWithPackageInfoCellLocalized}
                                    />
                                    {
                                        this.context.state.allowEditSuggestedOrders ?
                                            <Column
                                                key="orderQuantity"
                                                field="orderQuantity"
                                                title={this.props.returnLocalizedString("m0315")}
                                                headerClassName="numeric"
                                                className="numeric"
                                                width={this.setWidth(105, 8)}
                                                cell={OrderQuantityCell}
                                            /> : <React.Fragment />
                                    }
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                            {this.reportType === "parts-booking-history" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    rowRender={this.rowRender}
                                    onExpandChange={this.expandChange}
                                >
                                    <Column
                                        field="startDate"
                                        title={this.props.returnLocalizedString("m0481")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={100}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="endDate"
                                        title={this.props.returnLocalizedString("m0482")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={100}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="vendorName"
                                        title={this.props.returnLocalizedString("m0364")}
                                        width={180}
                                    />
                                    <Column
                                        field="partGroup"
                                        title={this.props.returnLocalizedString("m0600")}
                                        width={150}
                                    />
                                    <Column
                                        filterable={false}
                                        sortable={false}
                                        reorderable={false}
                                        width={90}
                                        cell={(props) => (
                                            <EditBookingButtonCell text={this.props.returnLocalizedString("m0111")} handleEditBooking={this.handleEditBooking} {...props} />
                                        )}
                                        editable={false}
                                    />
                                    <Column
                                        filterable={false}
                                        sortable={false}
                                        reorderable={false}
                                        width={90}
                                        cell={(props) => (
                                            <DeleteRecordCell text={this.props.returnLocalizedString("m0603")} showDeleteModal={this.showDeleteModal} {...props} />
                                        )}
                                        editable={false}
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                            {(this.reportType === "parts-return") && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    csvFilename={getExportFileName(exportFileName, 'csv')}
                                    allowUnsavedExcelExport={true}
                                    editField="inEdit"
                                    onItemChange={this.handleItemChange}
                                    csvData={this.getCsvData()}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="partNumber"
                                        title={this.props.returnLocalizedString("m0257")}
                                        width={this.setWidth(85, 10)}
                                    />
                                    <Column
                                        field="vendorCode"
                                        title={this.props.returnLocalizedString("m0259")}
                                        width={this.setWidth(70, 8)}
                                    />
                                    <Column
                                        field="partDescription"
                                        title={this.props.returnLocalizedString("m0258")}
                                        width={this.setWidth(155, 15)}
                                        cell={DescWithPackageInfoCellLocalized}
                                    />
                                    <Column
                                        field="maxSoldDate"
                                        title={this.props.returnLocalizedString("m0324")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(85, 10)}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="currentQtyAvailable"
                                        title={this.props.returnLocalizedString("m0348")}
                                        width={this.setWidth(85, 10)}
                                        className='numeric current'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="age"
                                        title={this.props.returnLocalizedString("m0611")}
                                        width={this.setWidth(90, 10)}
                                        className='numeric current'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="cost"
                                        title={this.props.returnLocalizedString("m0318")}
                                        width={this.setWidth(90, 10)}
                                        className='numeric'
                                        headerClassName='numeric'
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="total"
                                        title={this.props.returnLocalizedString("m0322")}
                                        width={this.setWidth(90, 10)}
                                        className='numeric'
                                        headerClassName='numeric'
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    {
                                        this.context.state.allowEditSuggestedOrders ?
                                            <Column
                                                key="orderQuantity"
                                                field="orderQuantity"
                                                title={this.props.returnLocalizedString("m0618")}
                                                headerClassName="numeric"
                                                className="numeric"
                                                width={this.setWidth(105, 11)}
                                                cell={OrderQuantityCell}
                                            /> : <React.Fragment />
                                    }
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                        </section>
                    </div>
                )}
            </AppContext.Consumer>
        );
    }
}
BookingsPage.contextType = AppContext;
export default compose(isPage)(BookingsPage);





// WEBPACK FOOTER //
// ./src/containers/BookingReturnsPage.js